var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItaly(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1500,
    height: 1000,
    viewBox: "0 0 3 2",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    fill: "#009246"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 1,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 2,
    fill: "#ce2b37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAwIiBoZWlnaHQ9IjEwMDAiIHZpZXdCb3g9IjAgMCAzIDIiPgo8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIyIiBmaWxsPSIjMDA5MjQ2Ii8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjIiIHg9IjEiIGZpbGw9IiNmZmYiLz4KPHJlY3Qgd2lkdGg9IjEiIGhlaWdodD0iMiIgeD0iMiIgZmlsbD0iI2NlMmIzNyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };